import * as Yup from 'yup';

const emailMessage: string = 'Please enter a valid email address.';

const upgradeAccountFormValidation = Yup.object({
  email: Yup.string().nullable().email(emailMessage).required(emailMessage)
}).required();

export { upgradeAccountFormValidation };
